import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['anchor', 'tabsContainer', 'tab']

  get activeTab() {
    return this.anchorTargets.find(anchor => anchor.classList.contains('active'))
  }

  connect() {
    if (this.activeTab) {
      const targetedTab = this.activeTab.dataset.targetedTab
      this.handleTabsDisplay(targetedTab)
    }
  }

  toggle(event) {
    const targetedTab = event.currentTarget.dataset.targetedTab
    this.tabsContainerTarget.classList.remove('d-none')
    this.anchorTargets.forEach(anchor => anchor.classList.remove('active'))
    event.currentTarget.classList.add('active')
    this.handleTabsDisplay(targetedTab)
  }

  handleTabsDisplay(targetedTab) {
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabIdentifier === targetedTab) {
        tab.classList.remove('d-none', 'hidden')
        tab.classList.add('show')
      } else {
        tab.classList.add('d-none', 'hidden')
        tab.classList.remove('show')
      }
    })
  }
}
